import React, { KeyboardEvent } from "react";


type focusType = KeyboardEvent<HTMLInputElement> | KeyboardEvent<HTMLSelectElement> | KeyboardEvent<HTMLButtonElement>
const focusTypeString = "input, button, select, textarea, [tabindex]:not([tabindex='-1'])";

// 포커스 이동 처리
const processFocusable = (e: focusType, processType: string = 'normal') => {
	// input 요소를 다시 포함시켜 모든 관련 입력 필드 및 tabindex가 지정된 요소를 검색합니다.
	const focusable = Array.from(document.querySelectorAll<HTMLElement>(focusTypeString))
	.filter(el => 
		!el.hasAttribute("disabled") && 
		!el.getAttribute("aria-hidden") &&
		el.getAttribute("name") !== "remove_input" // 이 조건은 name 속성이 없는 p 태그에는 영향을 주지 않습니다.
	);

	// console.log('focusable :', focusable);
	
	const index = focusable.indexOf(e.currentTarget as HTMLElement);

	
	// console.log('index :', index);
	// console.log('focusable test :', (index + 10) < focusable.length);
	// console.log('focusable test2 :', (index > -1 && index + 10 < focusable.length));

	// console.log('e.currentTarget.id :', e.currentTarget.id);
	// console.log('is tabIndex available? :', document.getElementById(e.currentTarget.id)?.tabIndex);
	// console.log('focus element :', focusable[index + 1]);
	// console.log('focus element :', focusable[index + 2]);
	// console.log('focus element :', focusable[index + 3]);
	// console.log('focus element :', focusable[index + 4]);
	// console.log('focus element :', focusable[index + 5]);
	// console.log('focus element :', focusable[index + 6]);
	// console.log('focus element :', focusable[index + 7]);
	// console.log('focus element :', focusable[index + 8]);


	
	if (index > -1 && index + 1 < focusable.length) {
		// console.log('processType :', processType);

		if(processType === 'normal') 										focusable[index + 1].click();
		else if(processType === 'focus')									focusable[index + 1].focus();
		else if(processType === 'focus+1' && index + 2 < focusable.length)	focusable[index + 2].focus();
		else if(processType === 'focus+2' && index + 3 < focusable.length)	focusable[index + 3].focus();
		else if(processType === 'focus+3' && index + 4 < focusable.length)	focusable[index + 4].focus();
		else if(processType === 'focus+4' && index + 5 < focusable.length)	focusable[index + 5].focus();
		else if(processType === 'focus+5' && index + 6 < focusable.length)	focusable[index + 6].focus();
		else if(processType === 'focus+6' && index + 7 < focusable.length)	focusable[index + 7].focus();
		else if(processType === 'focus+7' && index + 8 < focusable.length)	focusable[index + 8].focus();
		else if(processType === 'focus+8' && index + 9 < focusable.length)	focusable[index + 9].focus();
		else if(processType === 'focus+9' && index + 10 < focusable.length)	focusable[index + 10].focus();
	}
}

// 포커스 이동 처리
const processFocusable_tab = (e: focusType, processType: string = 'normal') => {
	// input 요소를 다시 포함시켜 모든 관련 입력 필드 및 tabindex가 지정된 요소를 검색합니다.
	const focusable = Array.from(document.querySelectorAll<HTMLElement>(focusTypeString))
	.filter(el => 
		!el.hasAttribute("disabled") && 
		!el.getAttribute("aria-hidden") &&
		el.getAttribute("name") !== "remove_input" // 이 조건은 name 속성이 없는 p 태그에는 영향을 주지 않습니다.
		&& el.tabIndex !== -1
	);

	// console.log('focusable :', focusable);
	
	const index = focusable.indexOf(e.currentTarget as HTMLElement);

	
	// console.log('index :', index);
	// console.log('focusable test :', (index + 10) < focusable.length);
	// console.log('focusable test2 :', (index > -1 && index + 10 < focusable.length));

	// console.log('e.currentTarget.id :', e.currentTarget.id);
	// console.log('is tabIndex available? :', document.getElementById(e.currentTarget.id)?.tabIndex);
	// console.log('focus element :', focusable[index + 1]);
	// console.log('focus element :', focusable[index + 2]);
	// console.log('focus element :', focusable[index + 3]);
	// console.log('focus element :', focusable[index + 4]);
	// console.log('focus element :', focusable[index + 5]);
	// console.log('focus element :', focusable[index + 6]);
	// console.log('focus element :', focusable[index + 7]);
	// console.log('focus element :', focusable[index + 8]);


	
	if (index > -1 && index + 1 < focusable.length) {
		// console.log('processType :', processType);

		if(processType === 'normal') 										focusable[index + 1].click();
		else if(processType === 'focus')									focusable[index + 1].focus();
		else if(processType === 'focus+1' && index + 2 < focusable.length)	focusable[index + 2].focus();
		else if(processType === 'focus+2' && index + 3 < focusable.length)	focusable[index + 3].focus();
		else if(processType === 'focus+3' && index + 4 < focusable.length)	focusable[index + 4].focus();
		else if(processType === 'focus+4' && index + 5 < focusable.length)	focusable[index + 5].focus();
		else if(processType === 'focus+5' && index + 6 < focusable.length)	focusable[index + 6].focus();
		else if(processType === 'focus+6' && index + 7 < focusable.length)	focusable[index + 7].focus();
		else if(processType === 'focus+7' && index + 8 < focusable.length)	focusable[index + 8].focus();
		else if(processType === 'focus+8' && index + 9 < focusable.length)	focusable[index + 9].focus();
		else if(processType === 'focus+9' && index + 10 < focusable.length)	focusable[index + 10].focus();
		else if(processType === 'focus-1' && index - 1 > -1)				focusable[index - 1].focus();
		else if(processType === 'focus-2' && index - 2 > -1)				focusable[index - 2].focus();
		else if(processType === 'focus-3' && index - 3 > -1)				focusable[index - 3].focus();
		else if(processType === 'focus-4' && index - 4 > -1)				focusable[index - 4].focus();
		else if(processType === 'focus-5' && index - 5 > -1)				focusable[index - 5].focus();
		else if(processType === 'focus-6' && index - 6 > -1)				focusable[index - 6].focus();
		else if(processType === 'focus-7' && index - 7 > -1)				focusable[index - 7].focus();
		else if(processType === 'focus-8' && index - 8 > -1)				focusable[index - 8].focus();
		else if(processType === 'focus-9' && index - 9 > -1)				focusable[index - 9].focus();
		else if(processType === 'focus-10' && index - 10 > -1)				focusable[index - 10].focus();
	}
}

export const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>, processType: string = 'normal') => {
	
	// console.log('e.currentTarget :', e.currentTarget);
	// console.log('e.shiftKey :', e.shiftKey, 'e.key :', e.key, 'processType :', processType);
	if (e.key === "Enter") {
		e.preventDefault();
		processFocusable(e, processType);
	}else if (e.shiftKey && e.key === "Tab") {
		e.preventDefault();
		processFocusable_tab(e, processType);
	}else if (e.key === "Tab") {
		e.preventDefault();
		processFocusable_tab(e, processType);
	}
}

export const handleKeyDownSelect = (e: KeyboardEvent<HTMLSelectElement>, processType: string = 'normal') => {
	if (e.key === "Enter") {
		e.preventDefault();
		processFocusable(e, processType);
	}else if (e.key === "Tab") {
		e.preventDefault();
		processFocusable_tab(e, processType);
    }
};

export const handleKeyDownButton = (e: KeyboardEvent<HTMLButtonElement>, processType: string = 'normal') => {
	e.preventDefault();
	processFocusable(e, processType);
}



//입력 포커스 이동을 위한 임시 e : 이벤트 객체
export const syntheticEvent = (targetIdString: string) => {
	return {
		key: "Enter",
		preventDefault: () => { /* console.log("Synthetic event preventDefault called"); */ },
		currentTarget: document.getElementById(targetIdString),
		target: document.getElementById(targetIdString),
	} as unknown as KeyboardEvent<HTMLInputElement>; // 보다 정확한 타입 캐스팅
}